export const gamePtBR: Record<string, string> = {
  "LE PUITS": "O POÇO",
  "LE PUITS · EN DIRECT": "O POÇO · AO VIVO",
  "DÉPOSE.": "DESCARTE.",
  "VIDE TA PILE": "ZERE SUA PILHA",
  "Vide ta pile": "Zere sua pilha",
  "À POSER": "PARA DESCARTAR",
  "RESTANTES": "RESTANTES",
  "PILE VIDE !": "PILHA ZERADA!",
  "VICTOIRE !": "VITÓRIA!",
  "CARTE POSÉE · +{xp} XP": "CARTA DESCARTADA · +{xp} XP",
  "{count} cartes au centre": "{count} cartas no centro",
  "{count} cartes posées. {errors} erreur.": "{count} cartas descartadas. {errors} erro.",
  "{count} cartes posées. {errors} erreurs.": "{count} cartas descartadas. {errors} erros.",
  "Cartes restantes des joueurs": "Cartas restantes dos jogadores",
  "Une carte au centre. Une pile chacun.": "Uma carta no centro. Uma pilha para cada um.",
  "Encore une carte": "Falta uma carta",
  "Salon": "Sala",
  "Scanne pour rejoindre": "Escaneie para entrar",
  "QR code pour rejoindre le salon {code}": "QR code para entrar na sala {code}",
  "QR code indisponible. Utilise le code du salon.": "QR code indisponível. Use o código da sala.",
  "CODE D’INVITATION": "CÓDIGO DA SALA",
  "COPIER LE LIEN": "COPIAR LINK",
  "JOUEURS": "JOGADORES",
  "HÔTE": "ANFITRIÃO",
  "COMMENCER": "COMEÇAR",
  "2 joueurs minimum": "Mínimo de 2 jogadores",
  "En attente de l’hôte": "Aguardando o anfitrião",
  "Le premier à vider sa pile gagne.": "Quem zerar a pilha primeiro vence.",
  "Une carte au centre. Les autres sont distribuées.": "Uma carta no centro. As outras são distribuídas.",
  "Nombre de cartes": "Quantidade de cartas",
  "{count} cartes": "{count} cartas",
  ORIGINAL: "ORIGINAL",
  "{count} cartes gagnées. {errors} erreur.": "{count} cartas ganhas. {errors} erro.",
  "{count} cartes gagnées. {errors} erreurs.": "{count} cartas ganhas. {errors} erros.",
  "Attendez le coup de sifflet.": "Aguarde o apito.",
  "{xp} XP gagnés": "{xp} XP ganhos",
  "{count} cartes restantes": "{count} cartas restantes",
  "{count} cartes gagnées": "{count} cartas ganhas",
  "{count} étoiles sur 3": "{count} estrelas de 3",
  "Virou! — À chaque image, un nouveau jeu.": "Virou! — A cada imagem, um novo jogo.",
  "BIEN VU !": "BOA!",
  "PAS CELUI-CI !": "NÃO É ESSE!",
  "Cherche le symbole commun.": "Procure o símbolo em comum.",
  "SÉRIE ×{count} !": "SEQUÊNCIA ×{count}!",
  "+1 CARTE · +{xp} XP": "+1 CARTA · +{xp} XP",
  "BADGE DÉBLOQUÉ · {names}": "CONQUISTA DESBLOQUEADA · {names}",
  "Série ×{count}": "Sequência ×{count}",
  "Belle partie !": "Jogou demais!",
  "Un joueur": "Um jogador",
  "{name} A TROUVÉ !": "{name} ACHOU!",
  "Nouvelle carte. À toi de jouer.": "Carta nova. Agora é com você.",
  "Le serveur se reconnecte. Réessaie dans un instant.":
    "Reconectando ao servidor. Tente de novo em instantes.",
  "Le serveur met trop de temps à répondre.":
    "O servidor está demorando para responder.",
  "Connexion interrompue. Réessaie.": "A conexão caiu. Tente de novo.",
  "Ton clic n’a pas pu être confirmé. Reconnexion…":
    "Não deu para confirmar seu toque. Reconectando…",
  "TROP TARD !": "QUASE!",
  "Impossible de reprendre la partie pour le moment.":
    "Não foi possível retomar a partida agora.",
  "COLLECTION COMPLÈTE": "COLEÇÃO COMPLETA",
  "TON PROCHAIN BADGE": "SUA PRÓXIMA CONQUISTA",
  "DÉBLOQUÉ ✓": "DESBLOQUEADO ✓",
  "SERVEUR PRÊT": "SERVIDOR PRONTO",
  "RECONNEXION…": "RECONECTANDO…",
  CARTES: "CARTAS",
  CARTE: "CARTA",
  "CARTE GAGNÉE": "CARTA GANHA",
  "CARTES GAGNÉES": "CARTAS GANHAS",
  FEUILLES: "FOLHAS",
  DIAMÈTRE: "DIÂMETRO",
  "{count} carte par page": "{count} carta por página",
  "{count} cartes par page": "{count} cartas por página",
  "Scores des joueurs": "Pontuação dos jogadores",
  TOI: "VOCÊ",
  ENTRAÎNEMENT: "TREINO",
  "LA TOUR · EN DIRECT": "A TORRE · AO VIVO",
  SÉRIE: "SEQUÊNCIA",
  "Quitter l’entraînement": "Sair do treino",
  "Quitter la partie": "Sair da partida",
  "Progression de la manche": "Progresso da rodada",
  "LA PIOCHE": "O MONTE",
  "TA PILE": "SUA PILHA",
  "TOUCHE LE SYMBOLE COMMUN": "TOQUE NO SÍMBOLO EM COMUM",
  "XP GAGNÉS": "XP GANHOS",
  "MEILLEURE SÉRIE": "MELHOR SEQUÊNCIA",
  "RÉFLEXE MOYEN": "REFLEXO MÉDIO",
  "RECONNEXION… Tes clics reprendront quand le serveur sera prêt.":
    "RECONECTANDO… Os toques voltam assim que a conexão retornar.",
  "LA PARTIE EST OUVERTE": "A PARTIDA ESTÁ ABERTA",
  RAMEUTE: "CHAME",
  "TA TEAM.": "A GALERA.",
  "LE CODE À PARTAGER": "COMPARTILHE ESTE CÓDIGO",
  "Un code. Tes potes. C’est tout.": "Um código. A galera. Só isso.",
  "INVITER LA TEAM": "CHAMAR A GALERA",
  "{cards} cartes · {symbols} symboles": "{cards} cartas · {symbols} símbolos",
  "LE SQUAD": "A GALERA",
  "{count} / 8 PRÊTS": "{count} / 8 PRONTOS",
  RECONNEXION: "RECONECTANDO",
  "HÔTE · PRÊT": "ANFITRIÃO · PRONTO",
  PRÊT: "PRONTO",
  "PLACE LIBRE": "VAGA LIVRE",
  "LANCER LA PARTIE": "COMEÇAR A PARTIDA",
  "Encore un joueur et c’est parti.": "Mais um jogador e já pode começar.",
  "Tout le monde joue en même temps. Prêts ?":
    "Todo mundo joga ao mesmo tempo. Bora?",
  "L’hôte lance la manche. Échauffe tes doigts !":
    "O anfitrião vai começar. Prepare os dedos!",
  "MANCHE TERMINÉE": "RODADA ENCERRADA",
  "BIEN JOUÉ,": "MANDOU BEM,",
  "CHAMPION !": "CAMPEÃO!",
  "LA PILE": "A PILHA",
  "A PARLÉ.": "DECIDIU.",
  "{names} gagnent la manche.": "{names} venceram a rodada.",
  "{names} gagne la manche.": "{names} venceu a rodada.",
  "REVANCHE !": "REVANCHE!",
  "L’hôte peut relancer une manche.": "O anfitrião pode começar outra rodada.",
  "RETOUR AU SALON": "VOLTAR AO INÍCIO",
  "Partie multijoueur": "Partida multijogador",
  "Entraînement solo": "Treino solo",
  "10 CARTES · AUCUNE PRESSION": "10 CARTAS · SEM PRESSÃO",
  "ENTRAÎNEMENT TERMINÉ": "TREINO CONCLUÍDO",
  "T’AS": "VOCÊ TEM",
  "LE RÉFLEXE.": "O REFLEXO.",
  "10 cartes gagnées. {errors} erreur.": "10 cartas ganhas. {errors} erro.",
  "10 cartes gagnées. {errors} erreurs.": "10 cartas ganhas. {errors} erros.",
  "PRÊT À DÉFIER TA BANDE ?": "BORA DESAFIAR A GALERA?",
  "JOUER EN MULTI": "JOGAR COM A GALERA",
  "ENCORE UN TOUR": "MAIS UMA RODADA",
  "LIEN COPIÉ · Fais tourner à ta team !":
    "LINK COPIADO · Mande para a galera!",
  "CODE : {code}": "CÓDIGO: {code}",
  "SON ACTIVÉ · Ça va cliquer !": "SOM LIGADO · Bora jogar!",
  "SON COUPÉ": "SOM DESLIGADO",
  "La connexion doit revenir avant de quitter.":
    "Aguarde a conexão voltar antes de sair.",
  "Le serveur ne répond pas.": "O servidor não está respondendo.",
  "Préparation de ta pile…": "Preparando sua pilha…",
  "Création des cartes : {current} / {total}":
    "Criando cartas: {current} / {total}",
  "Ta pile est téléchargée. À tes ciseaux !":
    "Sua pilha foi baixada. Hora de recortar!",
  "PDF PRÊT · Le jeu sort de l’écran.": "PDF PRONTO · O jogo sai da tela.",
  "L’export a échoué. Tu peux réessayer.":
    "A exportação falhou. Você pode tentar de novo.",
  "Impossible de préparer le PDF.": "Não foi possível criar o PDF.",
  "Attends la fin de l’export avant de changer de langue.":
    "Aguarde o fim da exportação antes de mudar de idioma.",
  "Trouver ton premier symbole commun.":
    "Encontrar seu primeiro símbolo em comum.",
};
